import React, { useState } from 'react';
import { useLocation } from 'react-router-dom'

const PaymentPage = () => {
    const [loading, setLoading] = useState(false);
    const location = useLocation()
    const invoiceData2 = (location.state as any)?.invoiceData
    return (
        <div className='card'>
            <div className='card-body'>
                <div className='row'>
                    {/* Left side - Invoice (70%) */}
                    <div className='col-lg-8'>
                        <div
                            style={{
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                minHeight: '842px',
                                backgroundColor: '#ffffff',
                                padding: '60px 50px',
                                fontFamily: 'Arial, sans-serif',
                                position: 'relative'
                            }}
                        >
                            {/* Top Section - Title and Basic Info */}
                            <div style={{ marginBottom: '80px' }}>
                                {/* Invoice Title at top right */}
                                <div style={{ textAlign: 'right', marginBottom: '100px' }}>
                                    <div style={{ display: 'inline-block', position: 'relative' }}>
                                        <div style={{
                                            position: 'absolute',
                                            left: '-200px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            width: '180px',
                                            height: '1px',
                                            backgroundColor: '#000'
                                        }}></div>
                                        <h1 style={{
                                            fontSize: '48px',
                                            letterSpacing: '12px',
                                            fontWeight: '300',
                                            margin: 0,
                                            color: '#000'
                                        }}>INVOICE</h1>
                                    </div>
                                </div>

                                {/* Two Column Layout */}
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    {/* Left Column */}
                                    <div style={{ flex: 1 }}>
                                        <div style={{ marginBottom: '50px' }}>
                                            <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '10px', letterSpacing: '0.5px' }}>ISSUED TO:</div>
                                            <div style={{ fontSize: '14px', lineHeight: '1.8', color: '#000' }}>
                                                <div>{invoiceData2?.clientName}</div>
                                                <div>{invoiceData2?.clientAddress?.street}</div>
                                                <div>{invoiceData2?.clientAddress?.city}, {invoiceData2?.clientAddress?.country}</div>
                                            </div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '10px', letterSpacing: '0.5px' }}>PAY TO:</div>
                                            <div style={{ fontSize: '14px', lineHeight: '1.8', color: '#000' }}>
                                                <div>DBS Bank</div>
                                                <div>Account Name : Consulere ASM Global LLP</div>
                                                <div>Account No. : 0123 4567 8901</div>
                                                <div>Swift : </div>
                                                <div>IFSC : </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Right Column */}
                                    <div style={{ paddingLeft: '40px' }}>
                                        <table style={{ marginLeft: 'auto', borderCollapse: 'collapse' }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ fontSize: '12px', fontWeight: 'bold', letterSpacing: '0.5px', textAlign: 'right', paddingRight: '10px', paddingBottom: '15px' }}>INVOICE NO:</td>
                                                    <td style={{ fontSize: '14px', paddingBottom: '15px' }}>{invoiceData2?.invoiceNo}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{ fontSize: '12px', fontWeight: 'bold', letterSpacing: '0.5px', textAlign: 'right', paddingRight: '10px', paddingBottom: '15px' }}>DATE:</td>
                                                    <td style={{ fontSize: '14px', paddingBottom: '15px' }}>
                                                        {invoiceData2?.invoiceDate ? new Date(invoiceData2.invoiceDate).toLocaleDateString('en-GB') : ''}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{ fontSize: '12px', fontWeight: 'bold', letterSpacing: '0.5px', textAlign: 'right', paddingRight: '10px' }}>DUE DATE:</td>
                                                    <td style={{ fontSize: '14px' }}>
                                                        {invoiceData2?.dueDate?.replace(/-/g, '/')}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            {/* Items Table */}
                            <div style={{ marginTop: '60px' }}>
                                {/* Table Header */}
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '2fr 1fr 1fr 0.8fr 1fr',
                                    borderBottom: '1px solid #000',
                                    paddingBottom: '10px',
                                    marginBottom: '15px',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    letterSpacing: '0.5px'
                                }}>
                                    <div>DESCRIPTION</div>
                                    <div style={{ textAlign: 'right' }}>START DATE</div>
                                    <div style={{ textAlign: 'right' }}>END DATE</div>
                                    <div style={{ textAlign: 'right' }}>QTY</div>
                                    <div style={{ textAlign: 'right' }}>AMOUNT</div>
                                </div>

                                {/* Table Row - Single row for fee structure */}
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '2fr 1fr 1fr 0.8fr 1fr',
                                    fontSize: '14px',
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                    alignItems: 'center'
                                }}>
                                    <div>
                                        {invoiceData2?.clientFeeStructure?.frequencyType} - {invoiceData2?.clientFeeStructure?.feeType}
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        {invoiceData2?.invoiceFromDate ? new Date(invoiceData2.invoiceFromDate).toLocaleDateString('en-GB') : ''}
                                    </div>
                                    <div style={{ textAlign: 'right' }}>
                                        {invoiceData2?.invoiceToDate ? new Date(invoiceData2.invoiceToDate).toLocaleDateString('en-GB') : ''}
                                    </div>
                                    <div style={{ textAlign: 'right' }}>1</div>
                                    <div style={{ textAlign: 'right' }}>${invoiceData2?.amount || 0}</div>
                                </div>
                            </div>

                            {/* Totals Section */}
                            <div style={{
                                marginTop: '40px',
                                borderTop: '1px solid #ddd',
                                paddingTop: '20px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    marginBottom: '50px'
                                }}>
                                    <div style={{
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        letterSpacing: '0.5px'
                                    }}>SUBTOTAL</div>
                                    <div style={{
                                        textAlign: 'right'
                                    }}>
                                        <div style={{ fontSize: '14px', marginBottom: '8px' }}>${invoiceData2?.amount || 0}</div>
                                        <div style={{ fontSize: '14px', marginBottom: '8px' }}>
                                            <span style={{ marginRight: '30px' }}>{invoiceData2?.clientFeeStructure?.taxType}</span>
                                            <span>{invoiceData2?.clientFeeStructure?.taxValue || 0}%</span>
                                        </div>
                                        <div style={{
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            letterSpacing: '0.5px',
                                            marginTop: '12px'
                                        }}>
                                            <span style={{ marginRight: '20px' }}>TOTAL</span>
                                            <span>${invoiceData2?.totalAmount || 0}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Signature */}
                            <div style={{
                                position: 'absolute',
                                bottom: '60px',
                                right: '50px',
                                fontFamily: 'Brush Script MT, cursive',
                                fontSize: '32px',
                                color: '#555'
                            }}>
                                Adeline Palmerston
                            </div>
                        </div>
                    </div>

                    {/* Right side - Payment Options (30%) */}
                    <div className='col-lg-4'>
                        <div className='d-flex flex-column gap-4 align-items-center'>
                            <button
                                className='btn py-3'
                                style={{ backgroundColor: '#333333', color: 'white', width: '280px' }}
                                onClick={() => {/* Handle update payment info */ }}
                            >
                                Update Payment Information
                            </button>
                            <div className='d-flex align-items-center gap-3' style={{ width: '80%' }}>
                                <hr style={{ flex: 1, borderTop: '1px solid #ccc' }} />
                                <span style={{ color: '#999' }}>or</span>
                                <hr style={{ flex: 1, borderTop: '1px solid #ccc' }} />
                            </div>
                            <button
                                className='btn py-3'
                                style={{ backgroundColor: '#333333', color: 'white', width: '280px' }}
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        Processing...
                                        <span className='spinner-border spinner-border-sm ms-2'></span>
                                    </>
                                ) : (
                                    'Use Payment Gateway'
                                )}
                            </button>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '20px', justifyContent: 'center' }}>
                                <div style={{ color: '#888', fontSize: '12px' }}>powered by</div>
                                <img src="/fmg2.png" alt="FMG" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentPage;